import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var AnalyticsOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M13.7505 6C13.3549 6 13.0338 6.32108 13.0338 6.7167V16.7505C13.0338 17.1461 13.3549 17.4672 13.7505 17.4672H16.6173C17.0129 17.4672 17.334 17.1461 17.334 16.7505V6.7167C17.334 6.32108 17.0129 6 16.6173 6H13.7505ZM14.4672 7.4334H15.9006V16.0338H14.4672V7.4334ZM8.73359 8.8668C8.33798 8.8668 8.01689 9.18788 8.01689 9.5835V16.7505C8.01689 17.1461 8.33798 17.4672 8.73359 17.4672H11.6004C11.996 17.4672 12.3171 17.1461 12.3171 16.7505V9.5835C12.3171 9.18788 11.996 8.8668 11.6004 8.8668H8.73359ZM9.45029 10.3002H10.8837V16.0338H9.45029V10.3002ZM3.7167 11.7336C3.32108 11.7336 3 12.0547 3 12.4503V16.7505C3 17.1461 3.32108 17.4672 3.7167 17.4672H6.5835C6.97911 17.4672 7.3002 17.1461 7.3002 16.7505V12.4503C7.3002 12.0547 6.97911 11.7336 6.5835 11.7336H3.7167ZM4.4334 13.167H5.8668V16.0338H4.4334V13.167Z",
    fill: fill
  }), React__default.createElement("path", {
    d: "M14.1962 2L10.4989 5.6973L7.91516 3.11356L3 8.02873L4.21786 9.24658L7.91516 5.54928L10.4989 8.13302L15.4141 3.21786L14.1962 2Z",
    fill: fill
  }));
};
export { AnalyticsOutline as default };
//# sourceMappingURL=AnalyticsOutline.js.map
